<script lang="ts" type="module">
	import Policies from '$lib/components/policies/policyList.svelte';
	import Wrapper from '$lib/components/utils/ResponsiveWrapper.svelte';
	import MetaTags from '$lib/components/utils/MetaTags.svelte';
</script>

<MetaTags
	title="Policies"
	desc="All our policies regarding billing, families etc are kept up to date here"
/>

<Wrapper title="Policies" transparent={true}>
	<div class="pt-8" />
	<div class="">
		<Policies />
	</div>
</Wrapper>
